var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbstractRailwayCompanyInput',_vm._g(_vm._b({attrs:{"items":_vm.railwayCompanies,"loading":_vm.railwayCompaniesLoading}},'AbstractRailwayCompanyInput',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }